import React,{useState,useEffect} from 'react'
import {Link} from 'react-router-dom'
import { API } from '../../api'


const Home = () =>{
    const user = JSON.parse(localStorage.getItem("user"))
    const [data,setData] = useState([])
    useEffect(()=>{
        fetch(`${API}/allpost`,{
            headers:{
                "Authorization" :"Bearer "+localStorage.getItem("jwt")
             }
        }).then(res=>res.json())
        .then(result=>{
            setData(result.posts)
        })
    },[])

    const likePost = (id)=>{
        console.log(id)
        fetch(`${API}/like`,{
            method:"put",
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            },
            body:JSON.stringify({
                postId:id
            }
            )

        }).then(res=>res.json())
        .then(result=>{
            console.log(result)
const newData = data.map(item=>{
                if(item._id===result._id){
                    return result
                }
                else{
                    return item
                }
            })            
            setData(newData)
        })
        .catch(err=>{
            console.log(err)
        })
    }

    const unlikePost = (id)=>{
        fetch(`${API}/unlike`,{
            method:"put",
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            },
            body:JSON.stringify({
                postId:id
            })
          
        }).then(res=>res.json())
        .then(result=>{
            console.log(result)
            const newData = data.map(item=>{
                if(item._id===result._id){
                    return result
                }
                else{
                    return item
                }
            })            
            setData(newData)
        })
    }

    const makeComment = (text,postId)=>{
        fetch(`${API}/comment`,{
            method:"put",
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            },body:JSON.stringify({
                text,
                postId
            })
           
        })
        .then(res=>res.json())
        .then(result=>{
            console.log(result)
            const newData = data.map(item=>{
                if(item._id===result._id){
                    return result
                }
                else{
                    return item
                }
            })            
            setData(newData)
        })
        .catch(err=>{
            console.log(err)
        })
    }

    const deletePost = (postid)=>{
        fetch(`${API}/deletepost/${postid}`,{
            method:"delete",
            headers:{
                "Authorization":"Bearer "+localStorage.getItem("jwt")
            }
        }).then(res=>res.json())
        .then(result=>{
            console.log(result)
            const newData = data.filter(item2=>{
                return item2._id!==result._id
                
            })
                      
            setData(newData)
        })
    }
    return(
        <div className="home">
            {
                data.map(item=>{
                    return(
                        <div className="card home-card" key={item._id} style={{border:"1px solid black"}}>
                        <h5 style={{textAlign:"center"}} className="brand-logo">{item.postedBy.name}
                       {item.postedBy._id=== user._id?<i className="material-icons" style={{float:"right"}} onClick={()=>deletePost(item._id)}>delete</i>:""} </h5>
                        <div className="card-image" style={{boxShadow:"2px",margin:"2px"}}>
                           <img src={item.photo} alt={item.title} style={{height:"400px",width:"400px",padding:"20px"}}></img>
                        </div>
                        <div className="card-content">
                    <h6>{item.likes.includes(user._id)?<i className="material-icons" style={{color:"red"}} onClick={()=>unlikePost(item._id)}>favorite</i>:<i className="material-icons" style={{color:"red"}} onClick={()=>likePost(item._id)}>favorite_border</i> }</h6>
                        <h6>{item.likes.length} Likes</h6>
                        <Link to={item.postedBy._id!== user._id?"/profile/"+item.postedBy._id:"/profile"}><i className="material-icons">subdirectory_arrow_right</i></Link>
                    <h4>{item.title}</h4>
                    <p>{item.body}</p>
                    {
                        item.comments.map(record=>{
                            return(
                            <h6 key={record._id}><span style={{fontWeight:"500"}}>{record.postedBy.name}</span>  {record.text}</h6>
                            )
                        })
                    }
                    

                    <form onSubmit={(e)=>{
                        e.preventDefault()
                        makeComment(e.target[0].value,item._id)
                    }}>
                    <input type="text" placeholder="Add comment"></input>
                    </form>
                            
        
                        </div>
                    </div>
                    )
                    
                })
            }



           

        </div>
    )
}

export default Home